// extracted by mini-css-extract-plugin
export default {"form":"AuthModal_form__Hgu9i","title":"AuthModal_title__Wi1zB","buttons":"AuthModal_buttons__wchvx","button":"AuthModal_button__7EhrI"};